import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "33",
  height: "33",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.14 13.663c-2.648-1.059-3.972-1.589-3.972-2.247S4.492 10.23 7.14 9.17l3.744-1.498c2.648-1.06 3.972-1.589 5.617-1.589s2.97.53 5.617 1.589l3.745 1.498c2.648 1.059 3.972 1.588 3.972 2.246s-1.324 1.188-3.972 2.247l-3.745 1.498c-2.648 1.06-3.971 1.589-5.617 1.589s-2.969-.53-5.617-1.589z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.168 11.416c0 .658 1.324 1.188 3.972 2.247l3.744 1.498c2.648 1.06 3.972 1.589 5.617 1.589s2.97-.53 5.617-1.589l3.745-1.498c2.648-1.059 3.972-1.589 3.972-2.247S28.51 10.23 25.863 9.17l-3.745-1.498c-2.648-1.06-3.971-1.589-5.617-1.589s-2.969.53-5.617 1.589L7.14 9.17c-2.648 1.059-3.972 1.588-3.972 2.246",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m8.19 14.083-1.05.42c-2.648 1.059-3.972 1.589-3.972 2.247s1.324 1.187 3.972 2.246l3.744 1.498c2.648 1.06 3.972 1.589 5.617 1.589s2.97-.53 5.617-1.589l3.745-1.498c2.648-1.059 3.972-1.588 3.972-2.246s-1.324-1.188-3.972-2.247l-1.05-.42-2.695 1.078c-2.648 1.06-3.971 1.589-5.617 1.589s-2.969-.53-5.617-1.589z",
      opacity: ".7"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m8.19 19.417-1.05.42c-2.648 1.059-3.972 1.589-3.972 2.247S4.492 23.27 7.14 24.33l3.744 1.498c2.648 1.06 3.972 1.589 5.617 1.589s2.97-.53 5.617-1.589l3.745-1.498c2.648-1.059 3.972-1.588 3.972-2.246s-1.324-1.188-3.972-2.247l-1.05-.42-2.695 1.078c-2.648 1.06-3.971 1.589-5.617 1.589s-2.969-.53-5.617-1.59z",
      opacity: ".4"
    }, null, -1)
  ])))
}
export default { render: render }